import PositionQuickCloseButton from './PositionQuickCloseButton';

export default PositionQuickCloseButton;
